import { render, staticRenderFns } from "./statusWarning.vue?vue&type=template&id=4b0aae79&scoped=true&"
import script from "./statusWarning.vue?vue&type=script&lang=js&"
export * from "./statusWarning.vue?vue&type=script&lang=js&"
import style0 from "./statusWarning.vue?vue&type=style&index=0&id=4b0aae79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0aae79",
  null
  
)

export default component.exports